import Vue from 'vue';
import Vuex from 'vuex';
import { menu } from './modules/menu.js'; // 菜单
import { system } from './modules/system.js'; // 布局需要的一些数据
Vue.use(Vuex);

export default new Vuex.Store({
  modules: { system, menu }
});
